// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\nWe are using normalize.css in npm to normalize browsers.\nCSS rules here are meant ONLY for global styling eg. scrollbar\n*/\n[data-elm-hot=\"true\"] {\n  height: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
